import React, { useState } from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Collapse, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import WebIcon from '@mui/icons-material/Web';

const SubmenuContainer = styled(Box)(({ theme }) => ({
  width: 200,
  height: '100vh',
  backgroundColor: '#F7FAFC',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  position: 'fixed',
  left: 80, // Position it right after the main sidebar
  top: 0,
  zIndex: 999,
  borderRight: '1px solid #E2E8F0',
}));

const WebsitesSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: '1px solid #E2E8F0',
  marginBottom: theme.spacing(2),
}));

const WebsitesHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const WebsitesTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 600,
  color: '#1A202C',
}));

const SubmenuItem = styled(ListItemButton)<{ active?: boolean }>(({ theme, active }) => ({
  padding: theme.spacing(1, 2),
  margin: theme.spacing(0.5, 1),
  borderRadius: 6,
  backgroundColor: active ? '#6B46C1' : 'transparent',
  color: active ? '#FFFFFF' : '#4A5568',
  '&:hover': {
    backgroundColor: active ? '#6B46C1' : '#EDF2F7',
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.9rem',
    fontWeight: active ? 600 : 500,
  },
}));

const WebsitesSubmenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [websitesOpen, setWebsitesOpen] = useState(true);

  const websitesSubmenuItems = [
    { label: 'Analytics', path: '/analytics', active: location.pathname === '/analytics' },
    { label: 'Blogs', path: '/blog', active: location.pathname === '/blog' },
  ];

  return (
    <SubmenuContainer>
      <WebsitesSection>
        <WebsitesHeader>
          <WebIcon sx={{ color: '#6B46C1', fontSize: 24 }} />
          <WebsitesTitle>Websites</WebsitesTitle>
          <IconButton
            size="small"
            onClick={() => setWebsitesOpen(!websitesOpen)}
            sx={{ marginLeft: 'auto', color: '#6B46C1' }}
          >
            {websitesOpen ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </WebsitesHeader>
        
        <Collapse in={websitesOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {websitesSubmenuItems.map((item, index) => (
              <ListItem key={index} disablePadding>
                <SubmenuItem
                  active={item.active}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.label} />
                </SubmenuItem>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </WebsitesSection>
    </SubmenuContainer>
  );
};

export default WebsitesSubmenu; 